export default "__VITE_ASSET__BbG$89Rn__"